import { render, staticRenderFns } from "./span-nullable.vue?vue&type=template&id=5be62a52&"
import script from "./span-nullable.vue?vue&type=script&lang=ts&"
export * from "./span-nullable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports